import { PageHeader } from "@/components/PageHeader";
import { BIZ } from "@/lib/content";
import { useSeo } from "@/lib/useSeo";

export default function Privacy() {
  useSeo({ title: "Privacy Policy | DST New Braunfels", description: "Privacy policy for Dynamic Sports Training New Braunfels." });
  return (
    <>
      <PageHeader eyebrow="Legal" title="Privacy Policy" />
      <section className="bg-dst-ink py-20 lg:py-28">
        <div className="container-dst max-w-3xl [&_h3]:font-oswald [&_h3]:uppercase [&_h3]:text-2xl [&_h3]:text-white [&_h3]:mt-10 [&_h3]:mb-3 [&_p]:text-white/60 [&_p]:leading-relaxed [&_p]:mb-4">
          <p>Dynamic Sports Training New Braunfels ("DST", "we", "us") respects your privacy. This policy explains how we handle information you share with us.</p>
          <h3>Information We Collect</h3>
          <p>When you submit our contact form, we collect the name, email, phone number, athlete age, area of interest, and message you provide. We use this information solely to respond to your inquiry and provide training services.</p>
          <h3>How We Use Your Information</h3>
          <p>We use your information to contact you about training, schedule sessions, and answer your questions. We do not sell or rent your personal information to third parties.</p>
          <h3>Data Storage</h3>
          <p>Contact submissions are stored securely and used only for communication related to DST services.</p>
          <h3>Contact</h3>
          <p>Questions about this policy? Email {BIZ.email} or call {BIZ.phone}.</p>
          <p className="text-white/40 text-sm">Last updated {new Date().getFullYear()}.</p>
        </div>
      </section>
    </>
  );
}
